import { Collapse, Space, Typography } from 'antd';
import type { ShiftFatigueViolation, UserShiftFatigueViolation } from './types';
import ViolationDisplay from './ViolationDisplay';

const { Text } = Typography;

const { Panel } = Collapse;

type UserFatigueAlertProps = {
  readonly violation: UserShiftFatigueViolation;
  readonly teamName: string;
};

/**
 * Alert section for user fatigue violations.
 */
const UserFatigueAlert = ({ violation, teamName }: UserFatigueAlertProps) => {
  const allViolations: readonly ShiftFatigueViolation[] = [
    ...violation.consecutiveShiftViolations,
    ...violation.maxShiftHoursViolations,
    ...violation.shiftRestGapViolations,
  ];

  const teamNamesWithViolation: readonly string[] = allViolations.flatMap(
    ({ shifts }) => shifts.flatMap((shift) => shift.team?.name ?? '')
  );

  const alertType = teamNamesWithViolation.includes(teamName)
    ? 'warning'
    : 'info';

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ display: 'flex', margin: '10px 0' }}
    >
      <Collapse>
        <Panel
          id={`${violation.userId}-violations-panel`}
          style={{
            backgroundColor: alertType === 'info' ? '#e6f4ff' : '#fffbe6',
          }}
          key={`${violation.userId}-violations`}
          header={
            <>
              <Text strong>{violation.userFullName}</Text> may experience
              fatigue,
              {alertType === 'info' ? <strong> in another team</strong> : ''}
              &nbsp; check details to review shifts.
            </>
          }
        >
          <ViolationDisplay userShiftFatigueViolation={violation} />
        </Panel>
      </Collapse>
    </Space>
  );
};

export default UserFatigueAlert;
